export const airlinesData = {
  // US Airlines
  'american-airlines': {
    name: 'American Airlines',
    code: 'AA',
    logo: 'https://images.kiwi.com/airlines/64/AA.png',
    description: 'American Airlines is the world\'s largest airline by fleet size, revenue, and passengers carried. Founded in 1930, it operates an extensive domestic and international network.',
    headquarters: 'Fort Worth, Texas, USA',
    founded: '1930',
    hubs: ['Dallas/Fort Worth', 'Charlotte', 'Chicago O\'Hare', 'Los Angeles', 'Miami', 'New York JFK', 'Philadelphia', 'Phoenix', 'Washington Reagan'],
    destinations: 350,
    fleet: 878,
    alliance: 'Oneworld',
    frequentFlyer: 'AAdvantage',
    classes: ['First Class', 'Business Class', 'Premium Economy', 'Main Cabin'],
    features: [
      'In-flight WiFi available',
      'Seat-back entertainment',
      'Mobile app for check-in',
      'AAdvantage loyalty program',
      'Premium lounges worldwide'
    ],
    bookingTips: [
      'Book 3-4 months in advance for best deals',
      'Tuesday and Wednesday flights often cheaper',
      'AAdvantage miles can be redeemed on Oneworld partners',
      'Free carry-on and personal item allowed'
    ],
    contactInfo: {
      phone: '1-800-433-7300',
      website: 'https://www.aa.com',
      customerService: '24/7 available'
    }
  },
  'delta-airlines': {
    name: 'Delta Air Lines',
    code: 'DL',
    logo: 'https://images.kiwi.com/airlines/64/DL.png',
    description: 'Delta Air Lines is one of the major airlines of the United States and a legacy carrier. Headquartered in Atlanta, Delta operates over 5,400 flights daily.',
    headquarters: 'Atlanta, Georgia, USA',
    founded: '1924',
    hubs: ['Atlanta', 'Boston', 'Detroit', 'Los Angeles', 'Minneapolis', 'New York JFK', 'Salt Lake City', 'Seattle'],
    destinations: 325,
    fleet: 865,
    alliance: 'SkyTeam',
    frequentFlyer: 'SkyMiles',
    classes: ['Delta One', 'First Class', 'Comfort+', 'Main Cabin'],
    features: [
      'Delta Studio entertainment',
      'Free messaging on flights',
      'Mobile boarding passes',
      'Delta Sky Club lounges',
      'SkyMiles program with no expiration'
    ],
    bookingTips: [
      'SkyMiles flash sales offer great deals',
      'Book on Tuesdays for potential price drops',
      'Main Cabin seats include free snacks',
      'Delta Comfort+ worth upgrade for extra legroom'
    ],
    contactInfo: {
      phone: '1-800-221-1212',
      website: 'https://www.delta.com',
      customerService: '24/7 available'
    }
  },
  'united-airlines': {
    name: 'United Airlines',
    code: 'UA',
    logo: 'https://images.kiwi.com/airlines/64/UA.png',
    description: 'United Airlines is a major American airline headquartered in Chicago, Illinois. It operates a comprehensive domestic and international route network.',
    headquarters: 'Chicago, Illinois, USA',
    founded: '1926',
    hubs: ['Chicago O\'Hare', 'Denver', 'Houston', 'Los Angeles', 'Newark', 'San Francisco', 'Washington Dulles', 'Guam'],
    destinations: 342,
    fleet: 843,
    alliance: 'Star Alliance',
    frequentFlyer: 'MileagePlus',
    classes: ['United Polaris', 'United First', 'United Premium Plus', 'Economy Plus', 'Economy'],
    features: [
      'United Polaris business class',
      'Personal device entertainment',
      'WiFi on most flights',
      'United Club lounges',
      'MileagePlus Shopping portal'
    ],
    bookingTips: [
      'Book Tuesday afternoons for best prices',
      'MileagePlus X app earns extra miles',
      'Economy Plus offers 6 inches extra legroom',
      'Star Alliance Gold status benefits across partners'
    ],
    contactInfo: {
      phone: '1-800-864-8331',
      website: 'https://www.united.com',
      customerService: '24/7 available'
    }
  },
  'southwest-airlines': {
    name: 'Southwest Airlines',
    code: 'WN',
    logo: 'https://images.kiwi.com/airlines/64/WN.png',
    description: 'Southwest Airlines is the world\'s largest low-cost carrier, known for its customer-friendly policies including no change fees and two free checked bags.',
    headquarters: 'Dallas, Texas, USA',
    founded: '1967',
    hubs: ['Atlanta', 'Baltimore', 'Chicago Midway', 'Dallas Love', 'Denver', 'Houston Hobby', 'Las Vegas', 'Oakland', 'Phoenix'],
    destinations: 121,
    fleet: 728,
    alliance: 'None (Independent)',
    frequentFlyer: 'Rapid Rewards',
    classes: ['Business Select', 'Anytime', 'Wanna Get Away'],
    features: [
      'Two free checked bags',
      'No change fees',
      'Free live TV and movies',
      'Rapid Rewards points never expire',
      'Friendly crew and service'
    ],
    bookingTips: [
      'Book 6-8 weeks ahead for domestic flights',
      'Early Bird Check-In guarantees better boarding',
      'Companion Pass is best deal (fly with friend free)',
      'Thursday fare sales common'
    ],
    contactInfo: {
      phone: '1-800-435-9792',
      website: 'https://www.southwest.com',
      customerService: '24/7 available'
    }
  },
  'jetblue-airways': {
    name: 'JetBlue Airways',
    code: 'B6',
    logo: 'https://images.kiwi.com/airlines/64/B6.png',
    description: 'JetBlue Airways is a major American low-cost airline known for its customer service, free amenities, and comfortable seating with extra legroom.',
    headquarters: 'New York, USA',
    founded: '1998',
    hubs: ['Boston', 'Fort Lauderdale', 'Los Angeles', 'New York JFK', 'Orlando'],
    destinations: 100,
    fleet: 280,
    alliance: 'None (Independent)',
    frequentFlyer: 'TrueBlue',
    classes: ['Mint', 'Even More Space', 'Core'],
    features: [
      'Free WiFi on all flights',
      'Free unlimited snacks and drinks',
      'Live TV at every seat',
      'Most legroom in coach',
      'Mint business class on select routes'
    ],
    bookingTips: [
      'TrueBlue points don\'t expire',
      'Book 3-4 months ahead for best fares',
      'Even More Space seats worth the upgrade',
      'Price match guarantee available'
    ],
    contactInfo: {
      phone: '1-800-538-2583',
      website: 'https://www.jetblue.com',
      customerService: '24/7 available'
    }
  },
  'alaska-airlines': {
    name: 'Alaska Airlines',
    code: 'AS',
    logo: 'https://images.kiwi.com/airlines/64/AS.png',
    description: 'Alaska Airlines is a major American airline headquartered in Seattle, known for excellent service and extensive West Coast network.',
    headquarters: 'Seattle, Washington, USA',
    founded: '1932',
    hubs: ['Anchorage', 'Los Angeles', 'Portland', 'San Diego', 'San Francisco', 'Seattle'],
    destinations: 115,
    fleet: 237,
    alliance: 'Oneworld',
    frequentFlyer: 'Mileage Plan',
    classes: ['First Class', 'Premium Class', 'Main Cabin'],
    features: [
      'Mileage Plan generous redemptions',
      'Free entertainment on devices',
      'WiFi available',
      'Alaska Lounge access',
      'Partner with American Airlines'
    ],
    bookingTips: [
      'Mileage Plan best for redeeming on partners',
      'Companion fare annual discount',
      'Book West Coast routes early',
      'Credit card perks include free bags'
    ],
    contactInfo: {
      phone: '1-800-252-7522',
      website: 'https://www.alaskaair.com',
      customerService: '24/7 available'
    }
  },

  // International Airlines
  'emirates': {
    name: 'Emirates',
    code: 'EK',
    logo: 'https://images.kiwi.com/airlines/64/EK.png',
    description: 'Emirates is the largest airline in the Middle East, operating over 3,600 flights per week. Known for luxury service and modern fleet.',
    headquarters: 'Dubai, UAE',
    founded: '1985',
    hubs: ['Dubai International'],
    destinations: 157,
    fleet: 259,
    alliance: 'None (Independent)',
    frequentFlyer: 'Emirates Skywards',
    classes: ['First Class', 'Business Class', 'Premium Economy', 'Economy Class'],
    features: [
      'A380 First Class suites',
      'ice entertainment system',
      'Onboard WiFi',
      'Gourmet dining',
      'Shower spas in First Class'
    ],
    bookingTips: [
      'Book 4-6 months ahead for best fares',
      'Premium Economy great value',
      'Dubai stopover packages available',
      'Skywards miles valuable for upgrades'
    ],
    contactInfo: {
      phone: '1-800-777-3999',
      website: 'https://www.emirates.com',
      customerService: '24/7 available'
    }
  },
  'lufthansa': {
    name: 'Lufthansa',
    code: 'LH',
    logo: 'https://images.kiwi.com/airlines/64/LH.png',
    description: 'Lufthansa is the largest German airline and one of the world\'s leading airlines, offering premium service and extensive European network.',
    headquarters: 'Cologne, Germany',
    founded: '1953',
    hubs: ['Frankfurt', 'Munich'],
    destinations: 220,
    fleet: 710,
    alliance: 'Star Alliance',
    frequentFlyer: 'Miles & More',
    classes: ['First Class', 'Business Class', 'Premium Economy', 'Economy Class'],
    features: [
      'FlyNet WiFi',
      'Premium dining',
      'First Class Terminal Frankfurt',
      'Miles & More elite benefits',
      'Modern fleet with new cabins'
    ],
    bookingTips: [
      'Book via Star Alliance partners for better rates',
      'Premium Economy worth upgrade on long-haul',
      'Frankfurt hub efficient for connections',
      'Miles & More Senator status very valuable'
    ],
    contactInfo: {
      phone: '1-800-645-3880',
      website: 'https://www.lufthansa.com',
      customerService: '24/7 available'
    }
  },
  'british-airways': {
    name: 'British Airways',
    code: 'BA',
    logo: 'https://images.kiwi.com/airlines/64/BA.png',
    description: 'British Airways is the flag carrier airline of the United Kingdom and one of the world\'s leading premium airlines.',
    headquarters: 'London, United Kingdom',
    founded: '1974',
    hubs: ['London Heathrow', 'London Gatwick', 'London City'],
    destinations: 183,
    fleet: 253,
    alliance: 'Oneworld',
    frequentFlyer: 'Executive Club',
    classes: ['First', 'Club World', 'World Traveller Plus', 'World Traveller'],
    features: [
      'Club Suite business class',
      'Luxurious First Wing at Heathrow',
      'Extensive lounge network',
      'Avios reward program',
      'Premium dining and service'
    ],
    bookingTips: [
      'Avios great for short-haul redemptions',
      'Book via Oneworld partners',
      'Club World seats at good prices',
      'Executive Club Gold status valuable'
    ],
    contactInfo: {
      phone: '1-800-247-9297',
      website: 'https://www.britishairways.com',
      customerService: '24/7 available'
    }
  },
  'air-france': {
    name: 'Air France',
    code: 'AF',
    logo: 'https://images.kiwi.com/airlines/64/AF.png',
    description: 'Air France is the flag carrier of France and a founding member of the SkyTeam alliance, known for French hospitality and cuisine.',
    headquarters: 'Paris, France',
    founded: '1933',
    hubs: ['Paris Charles de Gaulle', 'Paris Orly'],
    destinations: 175,
    fleet: 224,
    alliance: 'SkyTeam',
    frequentFlyer: 'Flying Blue',
    classes: ['La Première', 'Business', 'Premium Economy', 'Economy'],
    features: [
      'French cuisine and wines',
      'La Première ultimate luxury',
      'Modern entertainment systems',
      'Flying Blue program',
      'Premium lounges'
    ],
    bookingTips: [
      'Flying Blue Promo Rewards offer 50% off',
      'Book via SkyTeam partners',
      'Premium Economy excellent value',
      'Paris CDG hub convenient for Europe'
    ],
    contactInfo: {
      phone: '1-800-237-2747',
      website: 'https://www.airfrance.com',
      customerService: '24/7 available'
    }
  },
  'singapore-airlines': {
    name: 'Singapore Airlines',
    code: 'SQ',
    logo: 'https://images.kiwi.com/airlines/64/SQ.png',
    description: 'Singapore Airlines is widely regarded as one of the world\'s best airlines, known for exceptional service and innovative cabin products.',
    headquarters: 'Singapore',
    founded: '1947',
    hubs: ['Singapore Changi'],
    destinations: 132,
    fleet: 138,
    alliance: 'Star Alliance',
    frequentFlyer: 'KrisFlyer',
    classes: ['Suites', 'First Class', 'Business Class', 'Premium Economy', 'Economy'],
    features: [
      'A380 Suites with double bed',
      'Book the Cook dining',
      'KrisWorld entertainment',
      'Singapore Girl service',
      'Young fleet average 6 years'
    ],
    bookingTips: [
      'KrisFlyer miles valuable for premium cabin',
      'Book early for Suites/First',
      'Premium Economy worth the upgrade',
      'Changi Airport excellent for layovers'
    ],
    contactInfo: {
      phone: '1-800-742-3333',
      website: 'https://www.singaporeair.com',
      customerService: '24/7 available'
    }
  },
  'cathay-pacific': {
    name: 'Cathay Pacific',
    code: 'CX',
    logo: 'https://images.kiwi.com/airlines/64/CX.png',
    description: 'Cathay Pacific is the flag carrier of Hong Kong, renowned for premium service and one of the world\'s best business class products.',
    headquarters: 'Hong Kong',
    founded: '1946',
    hubs: ['Hong Kong International'],
    destinations: 119,
    fleet: 147,
    alliance: 'Oneworld',
    frequentFlyer: 'Asia Miles',
    classes: ['First Class', 'Business Class', 'Premium Economy', 'Economy'],
    features: [
      'Award-winning business class',
      'The Pier and The Wing lounges',
      'StudioCX entertainment',
      'Asia Miles program',
      'Premium service and catering'
    ],
    bookingTips: [
      'Business class regularly wins awards',
      'Asia Miles great for Oneworld redemptions',
      'Hong Kong hub efficient',
      'Premium Economy excellent value'
    ],
    contactInfo: {
      phone: '1-800-233-2742',
      website: 'https://www.cathaypacific.com',
      customerService: '24/7 available'
    }
  },
  'qantas': {
    name: 'Qantas',
    code: 'QF',
    logo: 'https://images.kiwi.com/airlines/64/QF.png',
    description: 'Qantas is Australia\'s largest airline and the flag carrier, with an excellent safety record and premium long-haul service.',
    headquarters: 'Sydney, Australia',
    founded: '1920',
    hubs: ['Sydney', 'Melbourne'],
    destinations: 85,
    fleet: 133,
    alliance: 'Oneworld',
    frequentFlyer: 'Qantas Frequent Flyer',
    classes: ['First', 'Business', 'Premium Economy', 'Economy'],
    features: [
      'A380 First Class suites',
      'Qantas Lounges worldwide',
      'Premium dining',
      'Excellent safety record',
      'Frequent Flyer program'
    ],
    bookingTips: [
      'Book via Oneworld partners',
      'Premium Economy good value',
      'Frequent Flyer points valuable',
      'Project Sunrise ultra-long-haul flights'
    ],
    contactInfo: {
      phone: '1-800-227-4500',
      website: 'https://www.qantas.com',
      customerService: '24/7 available'
    }
  },
  'ana': {
    name: 'All Nippon Airways',
    code: 'NH',
    logo: 'https://images.kiwi.com/airlines/64/NH.png',
    description: 'All Nippon Airways (ANA) is the largest airline in Japan, consistently rated among the world\'s best for service and quality.',
    headquarters: 'Tokyo, Japan',
    founded: '1952',
    hubs: ['Tokyo Haneda', 'Tokyo Narita'],
    destinations: 146,
    fleet: 222,
    alliance: 'Star Alliance',
    frequentFlyer: 'ANA Mileage Club',
    classes: ['First Class', 'Business Class', 'Premium Economy', 'Economy'],
    features: [
      'The Room business class',
      'Japanese hospitality',
      'Premium dining and sake',
      'ANA Lounge network',
      '5-star Skytrax rating'
    ],
    bookingTips: [
      'ANA Mileage Club excellent value',
      'Book via Star Alliance',
      'Premium Economy worth upgrade',
      'Tokyo hubs efficient for connections'
    ],
    contactInfo: {
      phone: '1-800-235-9262',
      website: 'https://www.ana.co.jp',
      customerService: '24/7 available'
    }
  },
  'etihad-airways': {
    name: 'Etihad Airways',
    code: 'EY',
    logo: 'https://images.kiwi.com/airlines/64/EY.png',
    description: 'Etihad Airways is the flag carrier of the UAE, known for luxury service and innovative cabin products including The Residence.',
    headquarters: 'Abu Dhabi, UAE',
    founded: '2003',
    hubs: ['Abu Dhabi International'],
    destinations: 76,
    fleet: 96,
    alliance: 'None (Equity Partners)',
    frequentFlyer: 'Etihad Guest',
    classes: ['The Residence', 'First Class', 'Business Class', 'Economy'],
    features: [
      'The Residence 3-room suite',
      'First Apartments',
      'Business Studios',
      'Premium dining',
      'Etihad Lounge'
    ],
    bookingTips: [
      'Abu Dhabi stopovers available',
      'Business class competitive pricing',
      'Etihad Guest miles valuable',
      'Book early for premium cabins'
    ],
    contactInfo: {
      phone: '1-877-690-0767',
      website: 'https://www.etihad.com',
      customerService: '24/7 available'
    }
  },
  'qatar-airways': {
    name: 'Qatar Airways',
    code: 'QR',
    logo: 'https://images.kiwi.com/airlines/64/QR.png',
    description: 'Qatar Airways is the state-owned flag carrier of Qatar, consistently ranked among the world\'s top airlines for service and quality.',
    headquarters: 'Doha, Qatar',
    founded: '1993',
    hubs: ['Hamad International Airport'],
    destinations: 173,
    fleet: 237,
    alliance: 'Oneworld',
    frequentFlyer: 'Privilege Club',
    classes: ['Qsuite', 'First Class', 'Business Class', 'Economy'],
    features: [
      'Award-winning Qsuite',
      'Al Mourjan lounge',
      'Oryx One entertainment',
      'Five-star service',
      'Modern fleet'
    ],
    bookingTips: [
      'Qsuite business class highly rated',
      'Privilege Club Avios valuable',
      'Doha hub excellent for connections',
      'Stopover packages available'
    ],
    contactInfo: {
      phone: '1-877-777-2827',
      website: 'https://www.qatarairways.com',
      customerService: '24/7 available'
    }
  }
};

export const getAirlineBySlug = (slug) => {
  return airlinesData[slug];
};

export const getAllAirlines = () => {
  return Object.entries(airlinesData).map(([slug, data]) => ({
    slug,
    ...data
  }));
};

export const getAirlinesByAlliance = (alliance) => {
  return Object.entries(airlinesData)
    .filter(([_, data]) => data.alliance === alliance)
    .map(([slug, data]) => ({ slug, ...data }));
};

export const searchAirlines = (query) => {
  const lowerQuery = query.toLowerCase();
  return Object.entries(airlinesData)
    .filter(([_, data]) => 
      data.name.toLowerCase().includes(lowerQuery) ||
      data.code.toLowerCase().includes(lowerQuery)
    )
    .map(([slug, data]) => ({ slug, ...data }));
};
